import css from './TnaModulesGeneral.module.css';

import toShort from '../../../../../services/utils/dateParser';
import DetailsGeneral from '../../../_common/elements/details/DetailsGeneral';
import { Link } from 'react-router-dom';

function TnaModulesGeneral({ moduleDetails, toggleModal, calculateTotalDuration }) {
    let content = {};
    let functions = {};

    // console.log(moduleDetails);

    content.info = [
        <p key={1}>
            Ref: <strong>{moduleDetails?.tnaModuleNo}</strong>
        </p>,
        <p key={2}>
            Module type: <strong>{moduleDetails?.tnaModuleType}</strong>
        </p>,
        <p key={3}>
            Rev.: <strong>{moduleDetails?.tnaModuleRevNo}</strong>
        </p>,
        <p key={4}>
            Date: <strong>{moduleDetails?.tnaModuleRevDate}</strong>
        </p>,
    ];

    content.notes = (
        <p key={5} className={css.notes} style={{ fontSize: '1rem' }}>
            <strong>Notes:</strong>
            <br />
            {moduleDetails?.tnaModuleNote}
        </p>
    );

    // at the moment it is only one option per student, if there are more in the future, this needs to be changed
    content.options = (
        <>
            <p>Affected TNA</p>
            <ul>
                {moduleDetails.affect?.map((x) => (
                        <li key={x.tnaId}>
                    <strong>
                            <Link to={`/tna/details/${x.tnaId}`}>{x.tnaNo}</Link>
                    </strong>
                        </li>
                ))}
            </ul>
        </>
    );

    content.additional = (
        <div className={css.qr}>
            <p>
                Duration: <strong>{calculateTotalDuration()} hours</strong>
            </p>
        </div>
    );

    functions.edit = toggleModal;

    return <DetailsGeneral content={content} functions={functions} />;
}

export default TnaModulesGeneral;
